import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  ViewChildren,
  QueryList,
  EventEmitter
} from '@angular/core';

import { ClientEventService } from '@radsource/ng-common-lib';

import { PatientInstance } from '../../objects/patient-instance';
import { StudyInstance } from '../../objects/study-instance';

import { InstanceService } from '../../services/instance.service';
import { DicomService } from '../../services/dicom.service';

import { StudyComponent } from '../study/study.component';

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import {
  FormBuilder,
  FormGroup,
} from '@angular/forms';

import { of } from 'rxjs';
import { MatSnackBar } from '@angular/material';

//This is a dependency of the Proton Xpress App Module
@Component({
  selector: 'patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.scss'],
  animations: [
    trigger('rowOptions', [
      state('inactive', style({
        opacity: .5,
      })),
      state('active', style({
        opacity: 1
      })),
      transition('inactive => active', animate('100ms ease-in')),
      transition('active => inactive', animate('100ms ease-out'))
    ])
  ]
})
export class PatientComponent implements OnInit {

  @Input() patient: PatientInstance;
  @Output() selfHeight: EventEmitter<number> = new EventEmitter<number>();
  studies: Array<StudyInstance> = new Array<StudyInstance>();
  patientPanelOpenState: Boolean = false;
  studyPanelOpenState: Boolean = false;
  showMRNEdit: Boolean = false;
  showNameEdit: Boolean = false;
  showDOBEdit: Boolean = false;
  showSexEdit: Boolean = false;
  organizationCode: string = "";
  errorText: string = null;
  deleting: Boolean = false;
  saving: Boolean = false;

  nameArr: Array<string> = new Array<string>();
  prefix: string = "";
  firstName: string = "";
  middleName: string = "";
  lastName: string = "";
  suffix: string = "";

  // expanded: Boolean = false;
  showEdit: Boolean = false;

  //animation states
  rowHover: string;
  rowEdit: string;

  patientForm: FormGroup;

  popoverText: string = "";
  @ViewChild('t', { static: false }) public tooltip: NgbTooltip;

  @ViewChild('rowHeight', { static: false }) patientContainer: any;

  @ViewChildren(StudyComponent) viewStudies: QueryList<StudyComponent> = new QueryList<StudyComponent>();

  studies$: any;

  constructor(
    public snackBar: MatSnackBar,
    public fb: FormBuilder,
    public is: InstanceService,
    public ces: ClientEventService,
    public ds: DicomService
  ) { }
  
  ngOnInit() {
    this.rowHover = 'inactive';

    this.ces.cancelStudyPush.subscribe(() => {
      let canceledStudies = this.patient.studies.filter((s) => s.canceled == true);
      if ( this.patient.studies.length == canceledStudies.length ) {

        this.patient.transferring = false;
        this.patient.transferring$ = of(this.patient.transferring);
        
        this.patient.pushAttempted = true;
        this.patient.pushAttempted$ = of(this.patient.pushAttempted);
      } 
    });
  }
  
  ngAfterViewChecked() {
    this.selfHeight.emit(this.patientContainer);
  }

  edit() {
    this.is.clearEditing();
    this.patient.editing = true;
    this.is.editPatient(this.patient);
  }

  closeEdit() {
    this.patient.editing = false;
    this.is.clearEditing();
    this.is.closeEdit();
  }

  closePopover() {
    this.popoverText = '';
    this.tooltip.close();
  }

  expandPopover() {
    if (this.patient.studies && this.patient.studies.length > 0) {
      (this.patient.expanded == false) ? this.popoverText = 'Show Studies' : this.popoverText = 'Hide Studies';
    } else {
      this.popoverText = 'No Studies'
    }
    this.tooltip.open(this.popoverText);
  }

  toggleRowHover(hoverState) {
    this.rowHover = hoverState;
  }

  togglePatient() {
    if (this.patient.studies && this.patient.studies.length > 0) {
      this.patient.expanded = !this.patient.expanded;
      this.patient.expanded$ = of(this.patient.expanded);
      this.expandPopover();
    }
  }

  delete(): any {
    this.deleting = true;
    this.patient.editing = false;
    this.is.deletePatientAsOwner(this.patient)
      .then((res) => {
        if (this.is.patientEditing && this.is.patientEditing.record_id == this.patient.record_id) {
          this.is.clearEditing();
          this.is.closeEdit();
        }
        this.deleting = false;
        this.ces.pushQueueDeletion.emit(this.patient);
      }).catch((err) => {
        this.deleting = false;
        console.log(err);
        this.snackBar.open("Deletion Failed", null, {
          duration: 1000,
        });
        // this.errorText = err;
      });
  }

}
